export interface Credentials {
  username: string;
  password: string;
}

export interface Settings {
  credentials: Credentials;
}

const settings: Settings = {
  credentials: {
    username: 'admin',
    password: 'password123',
  },
};

export default settings;

